import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { axiosClient } from '../services/api';
import { useI18n } from '../i18n/i18nContext';

export const SpouseResponsePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useI18n();
  const token = searchParams.get('token');
  const action = searchParams.get('action');

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [finalMessage, setFinalMessage] = useState('');

  useEffect(() => {
    if (!token || !action || !['accept', 'decline'].includes(action)) {
      setError(t.invitation.error);
      setIsLoading(false);
      return;
    }

    handleSpouseInviteResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, action]);

  const handleSpouseInviteResponse = async () => {
    setIsLoading(true);
    setError('');

    try {
      await axiosClient.post('/api/spouse-invites/respond', { token, action });
      setFinalMessage(action === 'accept' ? t.invitation.accepted : t.invitation.declined);
      setIsLoading(false);
    } catch (err: any) {
      const apiError = err?.response?.data?.error || t.invitation.error;
      setError(apiError);
      setIsLoading(false);
    }
  };

  const renderContent = () => {
    if (isLoading) return <p className="text-xl">{t.invitation.processing}</p>;
    if (error) return <p className="text-xl text-red-600 font-semibold">{error}</p>;
    if (finalMessage) return <p className="text-xl text-green-700 font-semibold">{finalMessage}</p>;

    return null;
  };

  return (
    <div className="container mx-auto px-4 py-12 md:py-20 text-center max-w-2xl">
      <h1 className="text-3xl font-bold mb-4">
        {error ? t.common.error : finalMessage ? t.common.success : t.invitation.processing}
      </h1>
      {renderContent()}
    </div>
  );
};